import { render, staticRenderFns } from "./PlatFormPage.vue?vue&type=template&id=215121ba&scoped=true&"
import script from "./PlatFormPage.vue?vue&type=script&lang=js&"
export * from "./PlatFormPage.vue?vue&type=script&lang=js&"
import style0 from "./PlatFormPage.vue?vue&type=style&index=0&id=215121ba&lang=scss&scoped=true&"
import style1 from "./PlatFormPage.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "215121ba",
  null
  
)

export default component.exports